import React from 'react';
import { UserIcon, MailIcon, PhoneIcon, BriefcaseIcon, LinkedinIcon, BuildingIcon, TagsIcon, MapPinIcon, DollarSignIcon } from 'lucide-react';
export function OwnerFinderFields() {
  return <section className="py-24 bg-slate-50" data-id="element-3781">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3782">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-3783">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-3784">
            What you get for every local business{' '}
            <span className="text-blue-600" data-id="element-3785">owner</span>
          </h2>
          <p className="text-xl text-slate-600" data-id="element-3786">
            Our local business owner finder returns verified contact data and
            rich business context for every result.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-3787">
          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-3788">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-3789">
              <UserIcon className="w-6 h-6" data-id="element-3790" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-3791">
              Owner name
            </h3>
            <p className="text-slate-600" data-id="element-3792">
              Full name of the local business owner or primary decision-maker.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-3793">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-3794">
              <MailIcon className="w-6 h-6" data-id="element-3795" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-3796">
              Verified email
            </h3>
            <p className="text-slate-600" data-id="element-3797">
              Verified local business owner email address ready for outreach.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-3798">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-3799">
              <PhoneIcon className="w-6 h-6" data-id="element-3800" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-3801">
              Direct phone
            </h3>
            <p className="text-slate-600" data-id="element-3802">
              Direct dial and mobile numbers for business owner contacts.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-3803">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-3804">
              <BriefcaseIcon className="w-6 h-6" data-id="element-3805" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-3806">Job title</h3>
            <p className="text-slate-600" data-id="element-3807">
              Owner, Founder, GM, Managing Partner, and other titles.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-3808">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-3809">
              <LinkedinIcon className="w-6 h-6" data-id="element-3810" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-3811">
              LinkedIn profile
            </h3>
            <p className="text-slate-600" data-id="element-3812">
              Direct link to the business owner's LinkedIn profile.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-3813">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-3814">
              <BuildingIcon className="w-6 h-6" data-id="element-3815" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-3816">
              Business name
            </h3>
            <p className="text-slate-600" data-id="element-3817">Full legal business name and DBA.</p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-3818">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-3819">
              <TagsIcon className="w-6 h-6" data-id="element-3820" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-3821">
              Business category
            </h3>
            <p className="text-slate-600" data-id="element-3822">
              Primary and secondary industry classifications.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-3823">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-3824">
              <MapPinIcon className="w-6 h-6" data-id="element-3825" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-3826">Location</h3>
            <p className="text-slate-600" data-id="element-3827">
              Full address, city, state, and ZIP code.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-3828">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-3829">
              <DollarSignIcon className="w-6 h-6" data-id="element-3830" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-3831">
              Revenue estimate
            </h3>
            <p className="text-slate-600" data-id="element-3832">
              Estimated annual revenue for qualifying leads.
            </p>
          </div>
        </div>
      </div>
    </section>;
}